module.exports = __webpack_public_path__ + "img/phone.41603720.png";